import * as React from 'react';
import classNames from 'classnames';
import { loadReviewSnippet } from '../../ReviewsContext/actions.js';
import { useReviewsContext } from '../../ReviewsContext/ReviewsContext.js';
import { REVIEW_SNIPPET_ID } from '../../ReviewsContext/constants.js';

const ReviewSnippet = ({ productId , variantId , className  })=>{
    const { enabled , dispatch  } = useReviewsContext();
    React.useEffect(()=>{
        if (enabled && productId) {
            dispatch(loadReviewSnippet({
                id: REVIEW_SNIPPET_ID,
                productId,
                variantId
            }));
        }
    }, [
        enabled,
        productId,
        variantId
    ]);
    if (!enabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames('review-snippet', className),
        "data-t": "review-snippet"
    }, /*#__PURE__*/ React.createElement("div", {
        id: REVIEW_SNIPPET_ID
    }));
};

export { ReviewSnippet as default };
//# sourceMappingURL=ReviewSnippet.js.map
